export default "__VITE_ASSET__D76FFOmJ__"